var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTag)?_c('span',{staticClass:"z-badge-text",class:_vm.customColor},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }